import { useState } from "react";
import Sidebar from "../../components/realestateagents/Sidebar";
import Navbar from "../../components/realestateagents/Navbar";
import FloatingMenuButton from "../../components/realestateagents/FloatingMenuButton";

const Layout = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="flex min-h-screen">
            {/* Mobile Overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div
                className={`fixed lg:sticky top-0 h-screen w-56 px-1 pt-2 pb-1 flex-col bg-white shadow-lg transform ${isOpen ? "translate-x-0" : "-translate-x-full"
                    } lg:translate-x-0 transition-transform duration-300 ease-in-out lg:flex`}
                style={{ backgroundColor: "#E0E0E0", zIndex: 9998 }}
            >
                <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>

            {/* Main content */}
            <div className="flex-1 flex flex-col pl-0 lg:pl-2">
                {/* Navbar */}
                <div className="fixed lg:sticky top-0 z-10 pt-4 px-1 xs:px-2 lg:px-4 w-full shadow-md lg:bg-transparent lg:shadow-none">
                    <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />
                </div>

                {/* Scrollable content */}
                <div className="pt-2 pb-2 lg:pt-0 lg:pb-2 px-1 xs:px-2 lg:px-1 flex-1 min-h-0 overflow-y-auto mt-14 lg:mt-0 mx-0.5 xs:mx-1 sm:mx-2 mb-2">
                    {children}
                </div>
            </div>

            {/* Floating Menu Button */}
            <FloatingMenuButton isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>
    );
};

export default Layout;
